import { observer } from 'mobx-react-lite'
import React from 'react'
import AuthenticationsPage from '../../../../ProjectManager/Influencer/AuthenticationsPage'
import InfluencerHeader from '../../../../ProjectManager/Influencer/InfluencerHeader'
import AuthenticationSidebar from './AuthenticationSidebar'
import { useSidebarCollapse } from '../../../../../contexts/SidebarCollapseContext'

export default observer(function AuthenticationPage() {
  const { isCollapsed } = useSidebarCollapse()

  return (
    <>
      <AuthenticationSidebar />
      <div className={`w-full min-h-full ${isCollapsed ? 'pl-14' : 'pl-56'} dark:bg-rb-dark-mode-background transition-all duration-300`}>
        <InfluencerHeader />
        <div className="bg-rb-grey dark:bg-rb-dark-mode-background">
          <div className="pl-4 pt-4 pr-2 dark:bg-rb-dark-mode-background">
            <AuthenticationsPage />
          </div>
        </div>
      </div>
    </>
  )
})

